import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Icons } from 'sarsaparilla';
import { attestFetchLoadingSelector, attestFetchSelector, attestStateSelector } from '../reducers/attestation';
import { attestUsers, fetchAttestation, fetchAttestationReset } from '../actions/attestation';
import { ATR, FACILITY_MANAGER, highestRoleAtLocation, PMO } from '../utilities/roles';

const propTypes = {
  attestState: PropTypes.shape({
    location: PropTypes.object,
    role: PropTypes.string,
  }).isRequired,
  attestData: PropTypes.shape({
    attested_at: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
  loadingPost: PropTypes.bool,
  onAttest: PropTypes.func.isRequired,
  fetchAttestation: PropTypes.func.isRequired,
  fetchAttestationReset: PropTypes.func.isRequired,
  loggedInUser: PropTypes.object,
};

export class Attestation extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const {
      attestState: { location, role },
      loading,
    } = this.props;
    if (role !== prevProps.attestState.role && !loading) {
      if (role) {
        this.props.fetchAttestation(location.location_type, location.location_id, role);
      } else {
        this.props.fetchAttestationReset();
      }
    }
  }

  shouldDisplay() {
    const {
      attestState: { location, role },
      loggedInUser,
    } = this.props;
    if (location && location.location_id && location.location_type && role) {
      const highestRole = highestRoleAtLocation(loggedInUser.roles, location);

      if (highestRole.location.location_id === location.location_id && highestRole.role_type === role) {
        return false;
      }

      return (
        highestRole.role_type === FACILITY_MANAGER || highestRole.role_type === PMO || highestRole.role_type === ATR
      );
    }
    return false;
  }

  render() {
    const {
      onAttest,
      attestState: { location, role },
      attestData,
      loadingPost,
    } = this.props;
    const ninetyDaysAgo = moment().add('day', -90);
    if (!this.shouldDisplay()) {
      return null;
    }
    return (
      <div className="attestation-wrapper">
        <Button
          isLoading={loadingPost}
          appearance="secondary"
          onClick={() => onAttest(location.location_type, location.location_id, role)}
        >
          Attest to Users
        </Button>
        {attestData.attested_at && (
          <div className="attested-at">
            Last Attested Date: {moment(this.props.attestData.attested_at).format('M/D/YY')}
            {moment(attestData.attested_at) >= ninetyDaysAgo && <Icons.IconCheckCircle size="md" />}
            {moment(attestData.attested_at) < ninetyDaysAgo && <Icons.IconCloseCircle size="md" />}
          </div>
        )}
      </div>
    );
  }
}

Attestation.propTypes = propTypes;

const mapStateToProps = (state) => ({
  loading: attestFetchLoadingSelector(state),
  loadingPost: attestFetchLoadingSelector(state),
  attestData: attestFetchSelector(state),
  attestState: attestStateSelector(state),
  loggedInUser: state.login.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onAttest: attestUsers,
      fetchAttestation,
      fetchAttestationReset,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Attestation);
